/* eslint-disable react/no-danger */
// Escapes `<` so a value (e.g. a listing title) can't close the <script>.
const JsonLd = ({ data }) => {
  if (!data) return null

  const json = JSON.stringify(data).replace(/</g, '\\u003c')

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  )
}

export default JsonLd
